import { getItem } from '@lib';
import { DEFAULT_LANGUAGE_CODE } from 'config/constants';
import { LANGUAGE } from 'config/storage';

const formatLanguageParam = (lang: null | string | undefined) => {
  if (!lang) return DEFAULT_LANGUAGE_CODE;

  const splitLang = lang.split('');

  if (splitLang.length === 2) {
    return lang;
  }

  return splitLang.slice(0, 2).join('');
};

const REFERRER_LOCALE_PATTERN = /\/(es-LA|es|pt)(?:\/|$)/i;

const isLandingPage = () => {
  const { pathname } = window.location;
  return pathname === '/' || pathname === '';
};

export const resolveLocaleCode = (): string => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE_CODE;

  const urlParams = new URLSearchParams(window.location.search);
  const fromUrl = urlParams.get('ln');
  if (fromUrl) return formatLanguageParam(fromUrl);

  const fromStorage = getItem(LANGUAGE);
  if (fromStorage) return formatLanguageParam(fromStorage);

  if (isLandingPage()) {
    const referrerMatch = document.referrer.match(REFERRER_LOCALE_PATTERN);
    if (referrerMatch)
      return formatLanguageParam(referrerMatch[1].toLowerCase());
  }

  return DEFAULT_LANGUAGE_CODE;
};
